/* Display only. Shopify remains responsible for discounts and checkout totals.
   Rules verified 9 Sep 2026: automatic discounts 2059383341343 / 2059383374111.
   Keep these tiers and gb-offer-eligible in step with merchant discount changes. */
(function () {
  'use strict';
  const TITLE20 = '20% off Order with 2 Items';
  const integer = n => Number.isSafeInteger(n) && n >= 0;
  function quote(snapshot, product, variantId, currency) {
    return null; // Quantity promotion retired 7 October 2026.
    if (!snapshot || snapshot.b2b || snapshot.currency !== currency || !/^[A-Z]{3}$/.test(currency || '') ||
        !Array.isArray(snapshot.items) || !snapshot.items.length || snapshot.cartDiscounts?.length ||
        !product?.eligible) return null;
    const variant = product.variants?.find(v => String(v.id) === String(variantId));
    if (!variant?.available || !integer(variant.price) || !variant.price) return null;
    const items = snapshot.items;
    // Do not estimate bundles, subscriptions, mixed eligibility or other promotions.
    if (items.some(i => !i.eligible || i.subscription || !integer(i.quantity) || !i.quantity ||
        !integer(i.price) || !integer(i.original) || !integer(i.final) || i.original !== i.price * i.quantity ||
        !Array.isArray(i.discounts))) return null;
    const quantity = items.reduce((n, i) => n + i.quantity, 0);
    if (quantity !== 1 && quantity !== 2) return null;
    const currentRate = quantity === 2 ? 20 : 0, nextRate = quantity === 2 ? 30 : 20;
    // Shopify rounds the discounted unit price up to a whole minor unit.
    // Verified against native AUD carts, including repeated quantities.
    if (items.some(i => {
      const discount = (i.price - Math.ceil(i.price * (100 - currentRate) / 100)) * i.quantity;
      return i.final !== i.original - discount || (currentRate === 0 ? i.discounts.length !== 0 :
        i.discounts.length !== 1 || i.discounts[0].title !== TITLE20 || !['', 'automatic'].includes(i.discounts[0].type) || i.discounts[0].valueType !== 'percentage' || Number(i.discounts[0].value) !== currentRate || i.discounts[0].amount !== discount);
    })) return null;
    const current = items.reduce((n, i) => n + i.final, 0);
    if (snapshot.total !== current) return null;
    const next = items.reduce((n, i) => n + Math.ceil(i.price * (100 - nextRate) / 100) * i.quantity, 0) + Math.ceil(variant.price * (100 - nextRate) / 100);
    const extra = next - current;
    if (!integer(extra) || extra <= 0 || extra >= variant.price) return null;
    return { extra, next, rate: nextRate, quantity: quantity + 1 };
  }
  function bundleProgress(snapshot) {
    return null; // Quantity promotion retired 7 October 2026.
    if (!snapshot || snapshot.b2b !== false || !Array.isArray(snapshot.items) || !Array.isArray(snapshot.cartDiscounts) || snapshot.cartDiscounts.length) return null;
    const items=snapshot.items;
    if(items.some(i=>typeof i.eligible!=='boolean'||typeof i.eligible30!=='boolean'||!integer(i.quantity)||!i.quantity||!integer(i.price)||!integer(i.original)||!integer(i.final)||!Array.isArray(i.discounts)))return null;
    const eligible=items.filter(i=>i.eligible30 && !i.subscription && i.price>0);
    const quantity=eligible.reduce((n,i)=>n+i.quantity,0),quantity20=eligible.filter(i=>i.eligible).reduce((n,i)=>n+i.quantity,0);
    const rate=quantity>=3?30:quantity20>=2?20:0;
    if(eligible.some(i=>{
      const expected=rate===30||rate===20&&i.eligible?rate:0;
      if(!expected)return i.discounts.length>0||i.final!==i.original;
      return !i.discounts.some(d=>d.title===expected+'% off Order with '+(expected===20?2:3)+' Items' && d.valueType==='percentage' && Number(d.value)===expected && ['','automatic'].includes(d.type) && d.amount>0);
    }))return null;
    const left20=Math.max(0,2-quantity20),left30=Math.max(0,3-quantity);
    const nextRate=rate===30?null:rate===20||left30<=left20?30:20;
    return {quantity,quantity20,rate,nextRate,remaining:nextRate===20?left20:nextRate===30?left30:0};
  }
  if (typeof window === 'undefined' && typeof module === 'object') { module.exports = { quote, bundleProgress }; return; }
  const context = document.getElementById('gb-picks-context');
  if (!context) return;
  const root = context.dataset.root.replace(/\/?$/, '/');
  const selector = '[data-rebuy-id="290288"]';
  let generation = 0, timer, observed, observer;
  const cache = new Map();
  async function read(path) {
    const url = new URL(path, location.origin);
    url.searchParams.set('section_id', 'gb-cart-value');
    const preview = new URLSearchParams(location.search).get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    const controller = new AbortController(), timeout = setTimeout(() => controller.abort(), 2500);
    try {
      const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: controller.signal });
      if (!response.ok) return null;
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      return JSON.parse(doc.querySelector('[data-gb-offer-data]')?.textContent || 'null');
    } catch { return null; } finally { clearTimeout(timeout); }
  }
  function guidance(snapshot) {
    const body=document.querySelector('#rebuy-cart [data-rebuy-cart-anchor="body"]');
    const template=document.getElementById('gb-cart-guidance-template');
    if(body && template && !body.querySelector(':scope > [data-gb-cart-guidance]'))body.prepend(template.content.cloneNode(true));
    const labels=JSON.parse(document.getElementById('gb-guidance-labels')?.textContent||'{}');
    const result=bundleProgress(snapshot);
    for(const block of document.querySelectorAll('[data-gb-cart-guidance]')){
      const progress=block.querySelector('[data-gb-bundle-progress]');progress.hidden=!result;
      if(result){
        const key=result.rate?'applied'+result.rate:'add'+result.nextRate;
        const message=(labels[key]||'').replace('__COUNT__',String(result.remaining));
        const text=progress.querySelector('[data-gb-bundle-message]');if(text.textContent!==message)text.textContent=message;
        progress.querySelector('progress').value=Math.min(3,result.quantity);
        const link=progress.querySelector('[data-gb-bundle-shop]');link.hidden=result.rate===30;link.href=root+'collections/'+(result.nextRate===20?'classic-prints':'tees');
      }
    }
  }
  function clear() { document.querySelectorAll(selector + ' .gb-cart-value').forEach(el => el.remove()); }
  function cartSignature(cart) {
    return JSON.stringify([cart?.currency, cart?.total_price, (cart?.items || []).map(i => [i.key, i.quantity, i.original_line_price, i.final_line_price])]);
  }
  function schedule() {
    generation++; clearTimeout(timer); clear();document.querySelectorAll('[data-gb-bundle-progress], [data-gb-cart-guidance] [data-gb-delivery-note]').forEach(el=>{el.hidden=true;});
    timer = setTimeout(update, 180);
  }
  function watch(el) {
    if (observed === el) return;
    observer?.disconnect(); observed = el;
    observer = new MutationObserver(records => {
      // Ignore our own notices so rendering cannot cause a request loop.
      if (records.some(r => r.type === 'attributes' || [...r.addedNodes, ...r.removedNodes].some(n =>
          !(n.nodeType === 1 && n.classList.contains('gb-cart-value'))))) schedule();
    });
    observer.observe(el, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
  }
  async function update() {
    const run = generation, el = document.querySelector(selector);
    if(el){watch(el);el.dataset.gbValueStatus = 'checking';}
    const cart = window.Rebuy?.Cart?.cart;
    const count = cart?.items?.reduce((n, i) => n + i.quantity, 0);
    const before = cartSignature(cart);
    const snapshot = await read(root + 'cart');
    if (run !== generation || before !== cartSignature(window.Rebuy?.Cart?.cart) || !snapshot || cart && snapshot.currency !== cart.currency) return;
    guidance(cart?.discount_codes?.length?{...snapshot,cartDiscounts:[true]}:snapshot);
    if(!el)return;
    if (count !== 1 && count !== 2 || cart?.discount_codes?.length) { el.dataset.gbValueStatus = 'ineligible-cart'; return; }
    el.dataset.gbValueStatus = 'data-ready';
    const blocks = [...el.querySelectorAll('.rebuy-product-block')].slice(0, 4);
    await Promise.all(blocks.map(async block => {
      const link = block.querySelector('.rebuy-product-title-link'), price = block.querySelector('.rebuy-product-price');
      if (!link || !price) return;
      const url = new URL(link.href, location.origin);
      url.pathname = url.pathname.replace(/\/collections\/[^/]+(?=\/products\/)/, '');
      if (url.origin !== location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[a-z0-9-]+$/.test(url.pathname)) return;
      const variantId = url.searchParams.get('variant'), selectedHref = link.href;
      if (!variantId) return;
      let entry = cache.get(url.pathname);
      if (!entry || Date.now() - entry.at > 60000 || entry.currency !== snapshot.currency) {
        const data = await read(url.pathname);
        if (!data?.product || data.currency !== snapshot.currency) return;
        entry = { product: data.product, currency: data.currency, at: Date.now() };
        cache.set(url.pathname, entry);
      }
      const value = quote(snapshot, entry.product, variantId, cart.currency);
      if (!value || run !== generation || !block.isConnected || link.href !== selectedHref || before !== cartSignature(window.Rebuy?.Cart?.cart)) return;
      const format = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: snapshot.currency, currencyDisplay: 'code' });
      const note = document.createElement('p'); note.className = 'gb-cart-value';
      const strong = document.createElement('strong');
      strong.textContent = 'Add for ' + format.format(value.extra / 100) + ' more';
      const detail = document.createElement('span');
      detail.textContent = value.rate + '% off eligible items. Before shipping and tax.';
      note.append(strong, detail); price.after(note); el.dataset.gbValueStatus = 'shown';
    }));
  }
  ['rebuy.ready', 'rebuy.productsChange', 'rebuy:cart.change', 'rebuy:cart.show', 'theme:cart:change', 'cart:updated', 'baseline:cart:afteradditem', 'baseline:cart:update', 'baseline:cart:cartqtychange'].forEach(name => document.addEventListener(name, schedule));
  document.addEventListener('change', e => { if (e.target.closest(selector+', #rebuy-cart, [data-cart-items]')) schedule(); });
  document.addEventListener('click', e => { if (e.target.closest(selector + ' .rebuy-product-actions, #rebuy-cart button')) schedule(); }, true);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) schedule(); });
  schedule();
})();
